export default "__VITE_ASSET__CpCRyOKe__"